module.exports = new __parcel__URL__("activateportal.e5fd3d55.png").toString();